import { render, staticRenderFns } from "./DatatableSomeProjects.vue?vue&type=template&id=3aa7fa1e&scoped=true&"
import script from "./DatatableSomeProjects.vue?vue&type=script&lang=js&"
export * from "./DatatableSomeProjects.vue?vue&type=script&lang=js&"
import style0 from "./DatatableSomeProjects.vue?vue&type=style&index=0&id=3aa7fa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa7fa1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
